module.exports = __webpack_public_path__ + "static/media/minimal-footer.94922579.jpg";